import React from 'react';

import {ResultsRowMetadata, ResultsTableMetadata} from 'notebook/integrations/results/ResultsTableConstants';
import {AddAPIPendingValuesActionButton} from 'notebook/structured-tables/components/buttons/AddAPIPendingValuesActionButton';
import {ToolbarButtonActionFunction} from 'notebook/structured-tables/StructuredTableConstants';

export const addAPIPendingValuesActionFunction: ToolbarButtonActionFunction<
  ResultsTableMetadata,
  ResultsRowMetadata
> = {
  renderToolbarButton: ({structuredTable, structuredTableAdapter, updateHandler}) => (
    <AddAPIPendingValuesActionButton
      structuredTable={structuredTable}
      structuredTableAdapter={structuredTableAdapter}
      updateHandler={updateHandler}
    />
  ),
};
